import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "CruisesFillGreenOnBlue__IconWrapper",
  componentId: "sc-18d738j-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 44 43",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    filter: "url(#CruisesFillGreenOnBlue_tsx__a)"
  }, React.createElement("path", {
    fill: themeGet("palette.highlight.light")(themeProps),
    stroke: themeGet("palette.pricePrimary.dark")(themeProps),
    d: "M26.995 7.358a1 1 0 0 0-.84-.458h-7.733a1 1 0 0 0-.83.444l.385.258-.386-.258-1.737 2.599a1 1 0 0 0 .832 1.555h11.146a1 1 0 0 0 .84-1.542z"
  }), React.createElement("path", {
    fill: themeGet("palette.text.heading")(themeProps),
    d: "m34.267 10-4.04-.002H14.354L10.317 10l-.14.012a.834.834 0 0 0-.692.87l.408 6.951-4.544 1.334-.134.052a.834.834 0 0 0-.408 1.051l5.734 14.658c-.239.18-.455.239-.758.239-.547 0-.808-.188-1.443-.95l-.208-.245c-.816-.933-1.418-1.305-2.515-1.305a.833.833 0 1 0 0 1.666c.547 0 .808.188 1.443.95l.209.245c.815.933 1.417 1.305 2.514 1.305 1.19 0 1.8-.44 2.723-1.55l.184-.218c.503-.58.76-.732 1.243-.732.538 0 .8.188 1.438.952l.21.244c.817.93 1.422 1.304 2.52 1.304 1.188 0 1.795-.437 2.723-1.55l.18-.211c.51-.587.77-.739 1.263-.739.547 0 .808.188 1.443.95l.209.245c.815.933 1.417 1.305 2.514 1.305 1.19 0 1.797-.437 2.724-1.55l.18-.211c.51-.587.77-.739 1.263-.739.545 0 .807.188 1.44.944l.215.252c.818.93 1.426 1.304 2.528 1.304 1.196 0 1.809-.44 2.731-1.55l.184-.218c.504-.58.762-.732 1.252-.732a.833.833 0 0 0 0-1.666c-1.186 0-1.794.437-2.712 1.543l-.185.22c-.508.584-.77.737-1.27.737-.293 0-.506-.053-.735-.216l5.728-14.681.041-.138a.834.834 0 0 0-.582-.965l-4.56-1.339.424-6.944-.004-.141a.834.834 0 0 0-.828-.743"
  }), React.createElement("path", {
    fill: themeGet("palette.pricePrimary.dark")(themeProps),
    d: "M22.988 3.184c-.064-.39-.37-.684-.738-.684-.414 0-.75.373-.75.833v3.4H23v-3.4z"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    fillRule: "evenodd",
    d: "m23.13 16.18 14.763 4.33-5.114 13.098c-.66-.666-1.238-.941-2.18-.941-1.097 0-1.698.372-2.514 1.305l-.389.456c-.51.587-.77.739-1.263.739s-.753-.153-1.263-.739l-.389-.456c-.577-.66-1.047-1.04-1.662-1.205zm-1.665-.005-.016 16.583c-.632.16-1.109.54-1.697 1.214l-.389.456c-.51.587-.77.739-1.263.739-.494 0-.758-.154-1.27-.74l-.395-.463c-.745-.849-1.312-1.232-2.24-1.29l-.192-.007-.108-.016c-.557-.057-1.116.122-1.69.515l-.247.182-.185.15-5.083-12.99z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.text.heading")(themeProps),
    fillRule: "evenodd",
    d: "M21.45 33.553c-.632.108-1.11.363-1.697.813l-.39.306c-.51.393-.77.495-1.262.495-.494 0-.758-.104-1.27-.496l-.395-.31c-.746-.568-1.312-.825-2.24-.863l-.192-.006-.108-.01c-.557-.038-1.116.082-1.69.345l-.247.122-.185.1-2.542-4.35L21.458 28zm11.33.57c-.66-.447-1.238-.63-2.179-.63-1.098 0-1.7.249-2.515.873l-.388.306c-.51.393-.771.495-1.264.495-.492 0-.752-.102-1.263-.495l-.388-.306c-.578-.442-1.048-.696-1.663-.807l.006-5.554 12.211 1.732z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.tint")(themeProps),
    fillRule: "evenodd",
    d: "m33.38 11.667-.347 5.68-10.498-3.08-.235-.034-.251.034-10.514 3.085-.335-5.685z",
    clipRule: "evenodd"
  })), React.createElement("defs", null, React.createElement("filter", {
    id: "CruisesFillGreenOnBlue_tsx__a",
    width: 48,
    height: 48,
    x: -1.75,
    y: -2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: 2
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.12 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_5730"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: 1
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.16 0"
  }), React.createElement("feBlend", {
    in2: "effect1_dropShadow_258_5730",
    result: "effect2_dropShadow_258_5730"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.24 0"
  }), React.createElement("feBlend", {
    in2: "effect2_dropShadow_258_5730",
    result: "effect3_dropShadow_258_5730"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: -1
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.03 0"
  }), React.createElement("feBlend", {
    in2: "effect3_dropShadow_258_5730",
    result: "effect4_dropShadow_258_5730"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect4_dropShadow_258_5730",
    result: "shape"
  }))));
}
const CruisesFillGreenOnBlue = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(CruisesFillGreenOnBlue);
export default Memo;